import axios from "axios";
import Swal from "sweetalert2";
import store from "../store";

/**
 * here we have the base url for all http request
 * that will be made to the REST API
 */
// const DEV_url = "http://209.105.243.210:8800/api/v1/";
// const LIVE_url = "http://209.105.243.210:8800";

 const LIVE_url = "https://reports.khuddam.ng/service";
export const url = LIVE_url;

/**
 * here we have all the possible enpoints that can be
 * used to access data on the REST API
 */
export const endpoints = {
  LOGIN: "/login/", // POST
  VERIFY_AUTH: "/auth/verify/",
  STATUS: "/api/v1/status/",
  CENSUS: "/api/v1/tajnid/",
  TARBIYYAH: "/api/v1/tarbiyya/",
  TABLIGH: "/api/v1/tabligh/",
  TALEEM: "/api/v1/taleem/",
  SECRETARIAT: "/api/v1/secretariat/",
  NEW_CONVERTS: "/api/v1/new-converts/",
  STUDENT: "/api/v1/student/",
  WAQAREMAL: "/api/v1/waqar-amal/",
  ATFAL: "/api/v1/atfal/",
  MAAL: "/api/v1/maal/",
  TAHRIK: "/api/v1/tahrik/",
  AUDIT: "/api/v1/audit/",
  HEALTH: "/api/v1/health/",
  TRADE: "/api/v1/trade/",
  ISHAAT: "/api/v1/ishaat/",
  SOCIAL:"/api/v1/social/",
  GENERAL: "/api/v1/general/",
  MY_QAIDEEN: "/api/v1/qaid/",
  QAID_STAT: "/api/v1/qaid/:id",
  SUBMITTED_REPORTS: "/api/v1/dashboard/"
};

/**
 * the in key is used to validate every request made to the REST API
 * this ensures that the request is secure and permitted.
 */
export const apiKey = "";

/**
 * default headers for http request
 */
export const headers = {
  "Content-Type": "application/json",
  // "Access-Control-Allow-Origin": "*"
};

/**
 * parse error response
 */
function parseError(error) {
  if (!error) {
    return Promise.reject("An unknown error occured.");
  }

  //console.log(error.response.data.error);

  if (typeof error === "string") {
    return Promise.reject(error);
  }

  if (error && error.response) {
    if (error.response.data && error.response.data.error) {
      return Promise.reject(error.response.data.error);
    }

    if (error.response.data && error.response.data.message) {
      return Promise.reject(error.response.data.message);
    }

    return Promise.reject("An unknown error occured.");
  }

  return Promise.reject(error.message || "An unknown error occured.");
}

/**
 * parse response
 */
function logout() {
  return {
    type: "LOGOUT_USER"
  };
}

function parseBody(response) {
  const { error } = response;
  console.log(store.getState());
  if (!error) {
    return response;
  } else {
    console.log(new Error(error.message));
    // if (error.message == "Network Error") {
    //   Promise.reject(error.message);
    // }

    return parseError(new Error(error));
  }
}

let instance = axios.create({
  baseURL: url
});

/**
 * add a response interceptor for axios instace
 */
instance.interceptors.response.use(
  response => {
    console.log(response.status);
    return parseBody(response);
  },
  error => {
    if (error.message!== null && error.message === "Network Error") {
      return Promise.reject(error.message);
    }

    if (error.response != null){
      if (error.response.status === 401 || error.response.status === 403) {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000
        });

        Toast.fire({
          type: "error",
          title: "You need to log in again "
        });
        store.dispatch(logout());
        window.location.replace("/");
        return Promise.reject("You need to log in again");
      }

    }

    return parseError(error);
  }
);

// request header
instance.interceptors.request.use(
  async config => {
    try {
      // get stored user
      // let user = await asyncGet(STORE_KEYS.AUTH_USER);
      let serializedState = localStorage.getItem("state");
      //if (serializedState === null) return undefined;
      let user = JSON.parse(serializedState);
      user = user.user;

      const state = store.getState();
      var authToken = null;
      if (state.person) authToken = state.person.user.token;

      // add default headers
      config.headers = Object.assign({}, config.headers, headers);
      // check if a user was found
      if (state.person) {
        // add user login token to request header
        config.headers = Object.assign({}, config.headers, {
          Authorization: `Bearer ${authToken}`
        });
      }
      // return transformed config
      return config;
    } catch (error) {
      // reject error if failed
      return Promise.reject(error);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * export instance as http
 */
export const http = instance;
